module.exports = __webpack_public_path__ + "media/images/flags/ni-9b7c3993e7ca4d65f06964a55417e643.svg";